<script setup lang="ts">
import type {Image} from "@spoferan/spoferan-ts-core";
import type {ImageSizeProp} from "../../types/image";

const props = withDefaults(defineProps<{

	// The source of the image to display
	src: string | Image,

	// The dimension data of the image it will be displayed
	size?: ImageSizeProp,

	ratio?: number,

	// The alt text of the image
	alt?: string,

	// The blur density to add to the image style
	blur?: number,

	// The gradient overlay
	gradient?: string,

	// Whether the image shall be fitted to the container
	fit?: boolean,
}>(), {
	size: {width: 280},
	ratio: null,
	alt: null,
	blur: null,
	gradient: null
});
</script>

<template>
	<cdn-image :src="props.src" :alt="props.alt" :size="props.size" :ratio="props.ratio ?? props.size.ratio ?? 4/2" class="flex-grow-0" :gradient="props.gradient" :blur="props.blur" :cover="!props.fit">
		<div v-if="$slots.default" class="absolute w-full h-full left-0 top-0">
			<slot/>
		</div>
	</cdn-image>
</template>